import { z } from "zod";
import { FinishingType } from "@/modules/property-tracks/types";

const nonNegativeInt = z.coerce
  .number({ invalid_type_error: "Must be a number" })
  .int("Must be a whole number")
  .min(0, "Must be 0 or greater");

const nonNegativeMoney = z.coerce
  .number({ invalid_type_error: "Must be a number" })
  .min(0, "Must be 0 or greater");

const positiveMoney = z.coerce
  .number({ invalid_type_error: "Must be a number" })
  .positive("Unit price is required");

const finishingValues = [
  "NotFinished",
  "Finished",
  "SemiFinished",
  "Furnished",
] as const satisfies readonly FinishingType[];

export const editListingSchema = z
  .object({
    actualPrice: positiveMoney,
    downpayment: nonNegativeMoney,
    remainingInstallments: nonNegativeMoney,
    maintenance: nonNegativeMoney.optional(),
    numberOfBedrooms: nonNegativeInt.optional(),
    numberOfBathrooms: nonNegativeInt.optional(),
    unitArea: nonNegativeInt.optional(),
    floorNumber: z.coerce.number().int().optional(),
    finishing: z.enum(finishingValues).optional(),
  })
  .refine(
    (data) => {
      const dp = Number(data.downpayment) || 0;
      const ri = Number(data.remainingInstallments) || 0;
      const total = dp + ri;
      // Only enforce when at least one installment field is set.
      if (dp === 0 && ri === 0) return true;
      return total === Number(data.actualPrice);
    },
    {
      message:
        "Down payment + Remaining installments must equal the unit price",
      path: ["remainingInstallments"],
    }
  );

export type EditListingFormValues = z.infer<typeof editListingSchema>;
